import {
  SET_FAVORITES_FROM_LOCAL_STORAGE,
  ADD_FAVORITE_EVENT,
  REMOVE_FAVORITE_EVENT,
} from 'Store/constants';

export const initialState = {
  data: [],
  isFetched: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_FAVORITES_FROM_LOCAL_STORAGE:
      return {
        data: action?.payload?.data ? [...action.payload.data] : [],
        isFetched: true
      };
    case REMOVE_FAVORITE_EVENT:
      return {
        data: state.data.filter(event => +event?.id !== +action.payload.eventId),
        isFetched: state.isFetched,
      };
    case ADD_FAVORITE_EVENT:
      return {
        data: state.data.concat(action.payload.event),
        isFetched: state.isFetched,
      };
    default:
      return state;
  }
};
